import { computed } from 'vue';
import { type RouteLocationPathRaw, useRoute, useRouter } from 'vue-router';
import { z } from 'zod';

export function useParams<T extends z.ZodRawShape>(scheme: z.ZodObject<T>) {
  const route = useRoute();
  const router = useRouter();

  const params = computed(() => scheme.parse(route.params));

  function updateParams (
    params: z.infer<typeof scheme>,
    options?: Pick<RouteLocationPathRaw, 'replace' | 'state'>,
  ) {
    void router.push({
      ...options,
      params: {
        ...route.params,
        ...params,
      },
      query: {
        ...route.query,
      },
    });
  }

  return {
    params,
    updateParams,
  };
}

export function useSearchParams<T extends z.ZodRawShape>(scheme: z.ZodEffects<z.ZodObject<T>> | z.ZodObject<T>) {
  const route = useRoute();
  const router = useRouter();

  const searchParams = computed(() => scheme.parse(route.query));

  function updateSearchParams (
    searchParams: z.infer<typeof scheme>,
    options?: Pick<RouteLocationPathRaw, 'replace' | 'state'>,
  ) {
    void router.push({
      ...options,
      query: {
        ...route.query,
        ...searchParams,
      },
    });
  }

  return {
    searchParams,
    updateSearchParams,
  };
}
